export default "__VITE_ASSET__B_JU_mvx__"